import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/download-icon.png'
import _imports_1 from '@/assets/img/review-icon.png'
import _imports_2 from '@/assets/img/code-icon.png'
import _imports_3 from '@/assets/img/chrome-icon.png'
import _imports_4 from '@/assets/img/edge-icon.png'
import _imports_5 from '@/assets/img/browser.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7b854728")

_pushScopeId("data-v-7b854728")
const _hoisted_1 = { id: "content" }
const _hoisted_2 = {
  key: 0,
  id: "main",
  class: "main-message"
}
const _hoisted_3 = {
  key: 1,
  id: "main",
  class: "main-message"
}
const _hoisted_4 = {
  key: 2,
  id: "main"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { id: "downloads" }, [
  /*#__PURE__*/_createVNode("div", { class: "download-item" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "https://chrome.google.com/webstore/detail/e-dnevnik-plus/bcnccmamhmcabokipgjechdeealcmdbe",
      target: "_blank",
      class: "card"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_0 }),
      /*#__PURE__*/_createTextVNode(" Preuzmi "),
      /*#__PURE__*/_createVNode("em", null, "proširenje"),
      /*#__PURE__*/_createTextVNode(" za učenike i roditelje ")
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://chrome.google.com/webstore/detail/e-dnevnik-plus/bcnccmamhmcabokipgjechdeealcmdbe/reviews",
      target: "_blank",
      class: "card"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_1 })
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://github.com/ChrisRoss5/e-Dnevnik-Plus",
      target: "_blank",
      class: "card"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_2 })
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "download-item" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "https://chrome.google.com/webstore/detail/e-dnevnik-plus-za-nastavn/jefappmpehdgllijkjpekdmkbmbigbnl",
      target: "_blank",
      class: "card"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_0 }),
      /*#__PURE__*/_createTextVNode(" Preuzmi "),
      /*#__PURE__*/_createVNode("em", null, "proširenje"),
      /*#__PURE__*/_createTextVNode(" za nastavnike ")
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://chrome.google.com/webstore/detail/e-dnevnik-plus-za-nastavn/jefappmpehdgllijkjpekdmkbmbigbnl/reviews",
      target: "_blank",
      class: "card"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_1 })
    ]),
    /*#__PURE__*/_createVNode("a", {
      href: "https://github.com/ChrisRoss5/e-Dnevnik-Plus-za-nastavnike",
      target: "_blank",
      class: "card"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_2 })
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  id: "browsers",
  class: "card"
}, [
  /*#__PURE__*/_createVNode("div", { style: {"padding-bottom":"10px"} }, "Kompatibilni preglednici:"),
  /*#__PURE__*/_createVNode("div", { id: "browser-icons" }, [
    /*#__PURE__*/_createVNode("div", { class: "flex-center" }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_3 }),
      /*#__PURE__*/_createTextVNode(" Chrome ")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "flex-center" }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_4 }),
      /*#__PURE__*/_createTextVNode(" Edge ")
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { id: "browser" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_5 })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "opacity",
      mode: "out-in"
    }, {
      default: _withId(() => [
        (_ctx.$route.hash == '#instaliran')
          ? (_openBlock(), _createBlock("div", _hoisted_2, " Proširenje je uspješno instalirano! "))
          : (_ctx.$route.hash == '#azuriran')
            ? (_openBlock(), _createBlock("div", _hoisted_3, " Proširenje je ažurirano na najnoviju verziju " + _toDisplayString(_ctx.$lastVersion) + "! ", 1))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6
              ]))
      ]),
      _: 1
    }),
    _hoisted_7
  ]))
})